import type { BonusCampaign } from '../../../../api/fetchers/bonusPromotions/types/bonus';

import type { Promotion } from './promotions';

export enum CampaignType {
  DefaultPromo,
  BonusPromo,
}

export type Campaign = Promotion | BonusCampaign;
